import { useContext, useState, useEffect } from 'react';
import { Grid, InputLabel, FormControl, Select, Button, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';
import { TablesContext } from '../TablesContext';
import { SapTableNames, LocalTableNames, } from '../../../../../helpers';
import { makeStyles } from '@material-ui/core/styles';
import { DbType } from '../../../../../helpers/Common';
import { getTableValuesItemsCodeByDBType } from '../../../../../helpers/Utils';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    formGroup: {
        width: '100%',
    },
    select: {
        width: '100%'
    },
    addbutton: {
    },
    mappings: {
        marginTop: theme.spacing(4)
    },
    removeButton: {
    }
}));

export const AccountGroupMappingEcc = (props) => {
    const classes = useStyles();

    const {
        state,
        getAccountGroupMappingsValueName,
        getAccountGroupMappingsValueNameCode,
        isAddingAccGroupMappingECC,
        addAccountGroupMappingECC,
        isDeletingAccGroupMapping,
        deleteAccountGroupMapping
    } = useContext(TablesContext);

    const {
        accountGroupMappingsECC
    } = state;

    const [salesOrganizationId, setSalesOrganizationId] = useState("");
    const salesOrgSelectHandler = (e) => {
        setSalesOrganizationId(e.target.value);
    };

    const [businessCategoryId, setBusinessCategoryId] = useState("");
    const buCateogrySelectHandler = (e) => {
        setBusinessCategoryId(e.target.value);
    };

    const [accountGroupId, setAccountGroupId] = useState("");
    const accountGroupSelectHandler = (e) => {
        setAccountGroupId(e.target.value);
    };

    const [customerGroupId, setCustomerGroupId] = useState("");
    const customerGroupSelectHandler = (e) => {
        setCustomerGroupId(e.target.value);
    };

    const [divisionId, setDivisionId] = useState("");
    const divisionSelectHandler = (e) => {
        setDivisionId(e.target.value);
    };

    const [distributionChannelId, setDistributionChannelId] = useState("");
    const distChannelSelectHandler = (e) => {
        setDistributionChannelId(e.target.value);
    };

    const addMappingClickHandler = async () => {
        const success = await addAccountGroupMappingECC({
            salesOrganizationId,
            businessCategoryId,
            accountGroupId,
            customerGroupId,
            divisionId,
            distributionChannelId
        });

        if (success) {
            setSalesOrganizationId("");
            setBusinessCategoryId("");
            setAccountGroupId("");
            setCustomerGroupId("");
            setDivisionId("");
            setDistributionChannelId("");
        }
    };

    const deleteMappingClickHandler = async (mapping) => {
        await deleteAccountGroupMapping(mapping.accountGroupMappingId, DbType.ECC);
    };

    const [canAddMapping, setCanAddMapping] = useState(false);
    useEffect(() => {
        setCanAddMapping(
            salesOrganizationId !== "" &&
            businessCategoryId !== "" &&
            accountGroupId !== "" &&
            customerGroupId !== "" &&
            divisionId !== "" &&
            distributionChannelId !== "" &&
            !isAddingAccGroupMappingECC
        );
    }, [salesOrganizationId, businessCategoryId, accountGroupId, customerGroupId, divisionId, distributionChannelId, isAddingAccGroupMappingECC]);

    const getOrderedMappings = () => {
        const orderedAccGrpMapping = [].concat(accountGroupMappingsECC);
        orderedAccGrpMapping.map(mapping => {
            mapping.salesOrganizationName = getAccountGroupMappingsValueNameCode(
                SapTableNames.SalesOrganizations,
                mapping.salesOrganizationId,
                DbType.ECC
            );
        });

        const sortBySalesOrganizationName = (a, b) => {
            if (
                (
                    a.salesOrganizationName &&
                    a.salesOrganizationName.split(" - ")[0]
                ) <
                (
                    b.salesOrganizationName &&
                    b.salesOrganizationName.split(" - ")[0]
                )
            )
                return -1;

            if (
                (
                    a.salesOrganizationName &&
                    a.salesOrganizationName.split(" - ")[0]
                ) >
                (
                    b.salesOrganizationName &&
                    b.salesOrganizationName.split(" - ")[0]
                )
            )
                return 1;

            return 0;
        };

        orderedAccGrpMapping.sort(sortBySalesOrganizationName);

        return orderedAccGrpMapping;
    };

    return (
        <Grid container>
            <Grid item xs={12}>
                <Grid
                    container
                    spacing={3}
                    justifyContent="flex-start"
                    alignItems="flex-end"
                >
                    <Grid item xs={12} sm={12} md={12} lg={2}>
                        <FormControl className={classes.formGroup}>
                            <InputLabel id="sales-group-label-ecc">
                                Sales Organization
                            </InputLabel>
                            <Select
                                labelId="sales-group-label-ecc"
                                className={classes.select}
                                value={salesOrganizationId}
                                disabled={isAddingAccGroupMappingECC}
                                onChange={salesOrgSelectHandler}>
                                {getTableValuesItemsCodeByDBType(SapTableNames.SalesOrganizations, state, DbType.ECC)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={2}>
                        <FormControl className={classes.formGroup}>
                            <InputLabel id="sales-group-label-ecc">
                                Business Category
                            </InputLabel>
                            <Select
                                labelId="sales-group-label-ecc"
                                className={classes.select}
                                value={businessCategoryId}
                                disabled={isAddingAccGroupMappingECC}
                                onChange={buCateogrySelectHandler}
                            >
                                {getTableValuesItemsCodeByDBType(LocalTableNames.BusinessCategories, state, DbType.ECC)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={2}>
                        <FormControl className={classes.formGroup}>
                            <InputLabel id="sales-group-label-ecc">
                                Account Group
                            </InputLabel>
                            <Select
                                labelId="sales-group-label-ecc"
                                className={classes.select}
                                value={accountGroupId}
                                disabled={isAddingAccGroupMappingECC}
                                onChange={accountGroupSelectHandler}
                            >
                                {getTableValuesItemsCodeByDBType(SapTableNames.AccountGroups, state, DbType.ECC)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={2}>
                        <FormControl className={classes.formGroup}>
                            <InputLabel id="sales-group-label-ecc">
                                Customer Group
                            </InputLabel>
                            <Select
                                labelId="sales-group-label-ecc"
                                className={classes.select}
                                value={customerGroupId}
                                disabled={isAddingAccGroupMappingECC}
                                onChange={customerGroupSelectHandler}
                            >
                                {getTableValuesItemsCodeByDBType(SapTableNames.CustomerGroups, state, DbType.ECC)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={2}>
                        <FormControl className={classes.formGroup}>
                            <InputLabel id="sales-group-label-ecc">
                                Distribution Channel
                            </InputLabel>
                            <Select
                                labelId="sales-group-label-ecc"
                                className={classes.select}
                                value={distributionChannelId}
                                disabled={isAddingAccGroupMappingECC}
                                onChange={distChannelSelectHandler}
                            >
                                {getTableValuesItemsCodeByDBType(SapTableNames.DistributionChannels, state, DbType.ECC)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={2}>
                        <FormControl className={classes.formGroup}>
                            <InputLabel id="sales-group-label-ecc">
                                Division
                            </InputLabel>
                            <Select
                                labelId="sales-group-label-ecc"
                                className={classes.select}
                                value={divisionId}
                                disabled={isAddingAccGroupMappingECC}
                                onChange={divisionSelectHandler}
                            >
                                {getTableValuesItemsCodeByDBType(SapTableNames.Divisions, state, DbType.ECC)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={2}>
                        <Button
                            className={classes.addbutton}
                            color="default"
                            variant="contained"
                            disabled={!canAddMapping}
                            onClick={addMappingClickHandler}
                        >
                            Add Mapping
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Table className={classes.mappings}>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                Sales Organization
                            </TableCell>
                            <TableCell>
                                Business Category
                            </TableCell>
                            <TableCell>
                                Account Group
                            </TableCell>
                            <TableCell>
                                Customer Group
                            </TableCell>
                            <TableCell>
                                Distribution Channel
                            </TableCell>
                            <TableCell>
                                Division
                            </TableCell>
                            <TableCell>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            getOrderedMappings().map((mapping, index: number): JSX.Element =>
                                <TableRow key={index}>
                                    <TableCell>
                                        {mapping.salesOrganizationName}
                                    </TableCell>
                                    <TableCell>
                                        {
                                            getAccountGroupMappingsValueName(
                                                LocalTableNames.BusinessCategories,
                                                mapping.businessCategoryId,
                                                DbType.ECC
                                            )
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {
                                            getAccountGroupMappingsValueNameCode(
                                                SapTableNames.AccountGroups,
                                                mapping.accountGroupId,
                                                DbType.ECC
                                            )
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {
                                            getAccountGroupMappingsValueNameCode(
                                                SapTableNames.CustomerGroups,
                                                mapping.customerGroupId,
                                                DbType.ECC
                                            )
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {
                                            getAccountGroupMappingsValueNameCode(
                                                SapTableNames.DistributionChannels,
                                                mapping.distributionChannelId,
                                                DbType.ECC
                                            )
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {
                                            getAccountGroupMappingsValueNameCode(
                                                SapTableNames.Divisions,
                                                mapping.divisionId,
                                                DbType.ECC
                                            )
                                        }
                                    </TableCell>
                                    <TableCell>
                                        <Button
                                            color="secondary"
                                            disabled={isDeletingAccGroupMapping}
                                            size="small"
                                            variant="contained"
                                            onClick={() => deleteMappingClickHandler(mapping)}
                                        >
                                            Delete
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            )
                        }
                    </TableBody>
                </Table>
            </Grid>
        </Grid>
    );
};